export const REQUIREMENT_PERMISSIONS = {
  workspace: {
    view: 'requirement:workspace:view',
  },
  record: {
    view: 'requirement:record:view',
    create: 'requirement:record:create',
    update: 'requirement:record:update',
    delete: 'requirement:record:delete',
  },
  task: {
    view: 'requirement:task:view',
    create: 'requirement:task:create',
    update: 'requirement:task:update',
    delete: 'requirement:task:delete',
  },
  bug: {
    view: 'requirement:bug:view',
    create: 'requirement:bug:create',
    update: 'requirement:bug:update',
    delete: 'requirement:bug:delete',
  },
  iteration: {
    view: 'requirement:iteration:view',
    create: 'requirement:iteration:create',
    update: 'requirement:iteration:update',
    delete: 'requirement:iteration:delete',
  },
  analytics: {
    view: 'requirement:analytics:view',
  },
  savedView: {
    view: 'requirement:saved_view:view',
    create: 'requirement:saved_view:create',
    update: 'requirement:saved_view:update',
    delete: 'requirement:saved_view:delete',
  },
} as const
